import { sortBy } from "lodash";
import React from "react";

import { DisplayName } from "@examspark/common-app";
import { Text, VSpace } from "@examspark/common-ui";
import { Resource, Vocabulary } from "@examspark/types";

import BrowseList from "../../components/browse/BrowseList";
import Loading from "../common/Loading";
import PageHead from "../common/PageHead";
import PageTitle from "../common/PageTitle";
import UnitContent from "../common/UnitContent";
import ResourceTools from "../resources/ResourceTools";

type Props = {
  vocabulary: Vocabulary | undefined | null;
  onBrowseResultNavigate?: React.ComponentProps<
    typeof BrowseList
  >["onResultNavigate"];
};

const VocabularyDetail = ({ vocabulary, onBrowseResultNavigate }: Props) => {
  if (vocabulary == null) {
    return <Loading />;
  }

  return (
    <VSpace size="2rem">
      <PageHead>
        <PageTitle
          subtitle="Vocabulary"
          tools={<ResourceTools resource={vocabulary} />}
        >
          <DisplayName resource={vocabulary} />
        </PageTitle>
      </PageHead>
      {vocabulary.description && (
        <VSpace size="0.5rem">
          <Text.H2>Definition</Text.H2>
          <UnitContent content={vocabulary.description} />
        </VSpace>
      )}
      <VSpace>
        <Text.H2>Explore Units / Modules Referencing this Term</Text.H2>
        <BrowseList
          data={
            sortBy(vocabulary.usages?.items, ["item.course.name", "item.name"])
              ?.map((usage) => usage.item)
              .filter((item) => item != null) as Resource[]
          }
          onResultNavigate={onBrowseResultNavigate}
        />
      </VSpace>
    </VSpace>
  );
};

export default VocabularyDetail;
